import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ColorSelectModule } from "src/app/components/color-select/color-select.module";
import { EventsPageRoutingModule } from "./events-routing.module";
import { EventsPage } from "./events.page";
import { EventResponseModule } from "src/app/pipes/event-response/event-response.module";
import { RRuleNextExecutionModule } from "src/app/pipes/rrule-next-execution/rrule-next-execution.module";
import { LogoModule } from "src/app/components/logo/logo.module";
import { FilterEventsModule } from "./pipes/filter-events/filter-events.module";
import { TranslateModule } from "@ngx-translate/core";
import { MapModulesModule } from "./pipes/map-modules/map-modules.module";
import { ToEventContentModule } from "src/app/pipes/to-event-content/to-event-content.module";
import { RescheduleButtonComponentModule } from "src/app/components/reschedule-button/reschedule-button.module";
import { IframeModalModule } from "src/app/modals/iframe-modal/iframe-modal.module";
import { EventAvailabilityModule } from "src/app/components/event-availability/event-availability.module";
import { GetAvailablePlacesPipeModule } from "src/app/pipes/get-available-places/get-available-places.module";
import { CanShowJoinButtonModule } from "src/app/modals/event/pipes/can-show-join-button/can-show-join-button.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    EventsPageRoutingModule,
    ColorSelectModule,
    RescheduleButtonComponentModule,
    EventResponseModule,
    RRuleNextExecutionModule,
    FilterEventsModule,
    LogoModule,
    TranslateModule,
    MapModulesModule,
    ToEventContentModule,
    IframeModalModule,
    EventAvailabilityModule,
    GetAvailablePlacesPipeModule,
    CanShowJoinButtonModule,
  ],
  declarations: [EventsPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EventsPageModule {}
